import { Box, Grid, Typography } from "@mui/material";
import "../../assets/css/header.css";
import { formatDateTime } from "../../utils/FormatDateUtils";

const Header = ({ solicitation, validSolicitation, error_404 }) => {
  const handleLogout = () => {};

  return (
    <Grid
      container
      className="header-wrapper"
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Grid
        item
        xs={5}
        sm={3}
        className="container-logo-header"
        style={{ marginTop: "0px" }}
      >
        <div className="logo-proxymus-header" />
      </Grid>

      {error_404 ? null : (
        <Grid item xs={7} sm={9} className="container-text-header">
          {validSolicitation === false ? null : (
            <>
              <Box className="box-text-header">
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: {
                      xs: "column",
                      md: "row",
                    },
                    flexWrap: "wrap",
                    gap: 1,
                    alignItems: "start",
                  }}
                >
                  <Typography
                    className="text-large-header"
                    sx={{ whiteSpace: "nowrap", fontWeight: 600 }}
                  >
                    Rilascio delega
                  </Typography>

                  <Typography
                    className="text-large-header"
                    sx={{
                      whiteSpace: {
                        xs: "normal",
                        md: "nowrap",
                      },
                      marginTop: { xs: "-10px", sm: "-10px", md: "0px" },
                    }}
                  >
                    Assemblea{" "}
                    {solicitation?.companyName?.length > 35
                      ? solicitation.companyName.substring(0, 35) + "..."
                      : solicitation?.companyName}{" "}
                    del {formatDateTime(solicitation?.meetingDate)}
                  </Typography>
                </Box>

                {/* <Typography className="text-minor-header">
                Durata del processo: inferiore a 5 minuti
              </Typography> */}
              </Box>
            </>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default Header;
